import translations from "../../translations/translations"
import { useContext } from 'react';
import LanguageContext from '../context/language-context';


const Print = (props) => {
    const languageCtx = useContext(LanguageContext);
    const dict = translations;

    if (props.value && props.children) {
        throw new Error("[Print] Provide either 'value' or 'children', not both.");
    }

    function print(id) {
        const ll = languageCtx.language;
        const record = dict.find(item => item.id === id);

        
        return record && record[ll]? record[ll] : '['+id+']';
    }

    return (
        <>
            {print(props.value || props.children)}
        </>
    )

}

export default Print